import { IImage } from 'modules/ScrShopNew/store/slices/shop/types';

export const filterDigitalGifs = (image: IImage, groupSlug: string) => {
  if (image.extension.toLowerCase() === 'gif') {
    // only include gifs that have the digital slug
    return groupSlug === 'digital';
  }

  // regular images are included if they belongs to a certain gallery
  return Boolean(image.gallery_id);
};
